module.exports = Em.Object.extend({
    api: Ember.inject.service(),

    isLoaded: false,

    data: null,

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    _baseURL: function() {
        var organization = this.get('organization')
        return '/v2/organizations/' + organization.get('id') + '/campaign'
    }.property('organization'),

    invalidate: function() {
        this.set('isLoaded', false)
            .set('data', null)
    }.observes('organization'),

    load: function() {
        var self = this
        this._loadPromise = this.get('api').request('GET', this.get('_baseURL'))
            .then(function(payload) {
                self.set('data', payload.campaign)
            }, function() {
                self.set('data', null)
            })
            .finally(function() {
                self.set('isLoaded', true)
            })
        return this._loadPromise
    },

    loadSafe: function() {
        this.load()
            .catch(function(e) {
                // Campaign load failed, but will not throw an error
            })
    },

    ensureLoaded: function() {
        return this._loadPromise || this.load()
    },

    getContent: function() {
        if (!this.get('isLoaded')) {
            throw new Error('Campaign has not been loaded yet.')
        }
        return Ember.copy(this.get('data'), true)
    },

    isApplicable: function() {
        return Ember.keys(this.get('data') || {}).length > 0
    },

    accept: function() {
        var self = this
        return this.get('api').request('POST', self.get('_baseURL') + '/accept', { payload: {} })
            .then(function() {
                self.load()
            })
    },

    decline: function() {
        var self = this
        return this.get('api').request('POST', self.get('_baseURL') + '/decline', { payload: {} })
            .then(function() {
                self.load()
            })
    }
})
